/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ReconnectInputs */

const en_common_reconnect = /** @type {(inputs: Common_ReconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnect`)
};

const es_common_reconnect = /** @type {(inputs: Common_ReconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a conectar`)
};

/**
* | output |
* | --- |
* | "Reconnect" |
*
* @param {Common_ReconnectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_reconnect = /** @type {((inputs?: Common_ReconnectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ReconnectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_reconnect(inputs)
	return en_common_reconnect(inputs)
});